/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { css, styled } from 'fierry/react';

import BorderType from 'solis/react/board/geometry/border.type';


const getDashoffset = ({ borderGeometry }) =>
{
  return borderGeometry.getDashoffset();
};


const borderStyle = css`

  fill: none;
  stroke: var(--accent-11);

  stroke-linecap: round;
  stroke-dashoffset: ${props => getDashoffset(props)};
`;


const ExternalBorder = styled.path`

  ${borderStyle}
  ${props => props.externalStyle}
`;


const TemporaryBorder = styled.path`

  ${borderStyle}
  ${props => props.temporaryStyle}
`;


const GroupBorder = styled.path`

  ${borderStyle}
  ${props => props.groupStyle}
`;


const ZoneBorder = styled.path`

  ${borderStyle}
  ${props => props.zoneStyle}
`;


const JaggedBorder = styled.path`

  ${borderStyle}
  ${props => props.jaggedStyle}
`;


const getPath = (borderGeometry) =>
{
  return 'M ' + borderGeometry.getOutlinePoints().map(point => `${point.x},${point.y}`).join(' L ');
};


const getBorderElement = (borderGeometry) =>
{
  switch (borderGeometry.getType())
  {
    case BorderType.External:       return ExternalBorder;
    case BorderType.Temporary:      return TemporaryBorder;
    case BorderType.Group:          return GroupBorder;
    case BorderType.Zone:           return ZoneBorder;
    case BorderType.Jagged:         return JaggedBorder;

    default:                        return null;
  }
};


// Basic data & geometry:
// - zoneData
// - hexGeometry
// - zoneGeometry

// Border style description:
// - externalStyle
// - temporaryStyle
// - groupStyle
// - zoneStyle
// - jaggedStyle


export default (props) =>
{
  return props.zoneGeometry.getBorders().map( (borderGeometry, index) =>
  {
    const Border = getBorderElement(borderGeometry);

    if (!Border)
    {
      return null;
    }

    return <Border {...props} key = {index} d = {getPath(borderGeometry)} borderGeometry = {borderGeometry} />;
  });
}
